import Actions from '../../../constants/inventory/InventoryActions';
import {
  AddActionLabels,
  RemoveActionLabels
} from '../../../constants/inventory/Reasons';

const {
  ADD,
  REMOVE,
  DAMAGED,
  SPOILED,
  FOUND_NEW,
  LOST,
  EXPIRED,
  STOLEN,
  DONATION_RECEIVED,
  DONATION_REMOVED,
  DONATED,
  ADD_CORRECTION,
  REMOVE_CORRECTION,
  PURCHASED,
  SOLD,
  DISTRIBUTION_RECEIVED,
  DISTRIBUTED
} = Actions;

export const AddReasonOptions = [
  { value: ADD, label: AddActionLabels[ADD] },
  { value: ADD_CORRECTION, label: AddActionLabels[ADD_CORRECTION] },
  { value: FOUND_NEW, label: AddActionLabels[FOUND_NEW] },
  { value: PURCHASED, label: AddActionLabels[PURCHASED] },
  { value: DONATION_RECEIVED, label: AddActionLabels[DONATION_RECEIVED] },
  {
    value: DISTRIBUTION_RECEIVED,
    label: AddActionLabels[DISTRIBUTION_RECEIVED]
  }
];

export const RemoveReasonOptions = [
  { value: REMOVE, label: RemoveActionLabels[REMOVE] },
  { value: DONATION_REMOVED, label: RemoveActionLabels[DONATION_REMOVED] },
  { value: REMOVE_CORRECTION, label: RemoveActionLabels[REMOVE_CORRECTION] },
  { value: DONATED, label: RemoveActionLabels[DONATED] },
  { value: DISTRIBUTED, label: RemoveActionLabels[DISTRIBUTED] },
  { value: SOLD, label: RemoveActionLabels[SOLD] },
  { value: DAMAGED, label: RemoveActionLabels[DAMAGED] },
  { value: SPOILED, label: RemoveActionLabels[SPOILED] },
  { value: LOST, label: RemoveActionLabels[LOST] },
  { value: EXPIRED, label: RemoveActionLabels[EXPIRED] },
  { value: STOLEN, label: RemoveActionLabels[STOLEN] }
];

export const ReasonsByActionOptions = {
  [ADD]: AddReasonOptions,
  [REMOVE]: RemoveReasonOptions
};
